export function embedOverlay() {
  const containers = document.querySelectorAll('.wp-block-embed, .farlo-ui-video');

  const withAutoplay = (url) => {
    if (!url) return url;
    try {
      const u = new URL(url, window.location.href);
      u.searchParams.set('autoplay', '1');
      if (/vimeo\.com$/i.test(u.hostname) || /player\.vimeo\.com$/i.test(u.hostname)) {
        u.searchParams.set('muted', '1');
        u.searchParams.set('playsinline', '1');
      }
      if (/youtube\.com$/i.test(u.hostname) || /youtube-nocookie\.com$/i.test(u.hostname)) {
        u.searchParams.set('playsinline', '1');
      }
      return u.toString();
    } catch {
      const sep = url.includes('?') ? '&' : '?';
      return `${url}${sep}autoplay=1`;
    }
  };

  // Adds JS API params so postMessage play commands work after pre-load.
  const withApiParams = (url) => {
    if (!url) return url;
    try {
      const u = new URL(url, window.location.href);
      if (/youtube\.com$/i.test(u.hostname) || /youtube-nocookie\.com$/i.test(u.hostname)) {
        u.searchParams.set('enablejsapi', '1');
        u.searchParams.set('playsinline', '1');
      }
      if (/vimeo\.com$/i.test(u.hostname) || /player\.vimeo\.com$/i.test(u.hostname)) {
        u.searchParams.set('playsinline', '1');
      }
      return u.toString();
    } catch {
      return url;
    }
  };

  // Send a play command to an already-loaded YouTube or Vimeo iframe.
  // Called within a click handler so it counts as a user gesture on iOS.
  const postPlayCommand = (iframe) => {
    if (!iframe?.contentWindow) return;
    const src = iframe.src || iframe.dataset.src || '';
    try {
      const host = new URL(src).hostname;
      if (/youtube\.com$|youtube-nocookie\.com$/i.test(host)) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'playVideo', args: [] }),
          '*'
        );
      } else if (/vimeo\.com$|player\.vimeo\.com$/i.test(host)) {
        iframe.contentWindow.postMessage(
          JSON.stringify({ method: 'play' }),
          'https://player.vimeo.com'
        );
      }
    } catch (e) {}
  };

  containers.forEach((container) => {
    const wrapper = container.querySelector('.wp-block-embed__wrapper') || container;
    let overlay   = wrapper.querySelector('.wp-block-embed__overlay');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'wp-block-embed__overlay';
      wrapper.appendChild(overlay);
    }

    if (!overlay.querySelector('.play-button')) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'play-button';
      btn.setAttribute('aria-label', 'Play video');
      btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M72,39.88V216.12a8,8,0,0,0,12.15,6.69l144.08-88.12a7.82,7.82,0,0,0,0-13.38L84.15,33.19A8,8,0,0,0,72,39.88Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>`;
      Object.assign(btn.style, {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        background: 'var(--global-primary-colour)',
        padding: '25px',
        borderRadius: '9999px',
        fontSize: '20px',
        color: '#fff',

      });
      overlay.appendChild(btn);
    }

    // Pre-load the iframe (with JS API params) when it scrolls into view so that
    // postPlayCommand() can fire within the click handler — this is what makes
    // single-tap play work on iOS, which blocks autoplay triggered by src changes.
    const lazyIframe = wrapper.querySelector('iframe[data-src]:not([src])');
    if (lazyIframe) {
      const io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          lazyIframe.setAttribute('src', withApiParams(lazyIframe.dataset.src));
          io.disconnect();
        }
      }, { rootMargin: '200px' });
      io.observe(container);
    }

    overlay.addEventListener('click', () => {
      // Re-query at click time so we pick up any iframes injected after init (e.g. by wp-embed.js)
      const liveIframe   = wrapper.querySelector('iframe');
      const dataSrc      = liveIframe?.dataset?.src;
      const currentSrc   = liveIframe?.getAttribute('src') || null;
      const containerSrc = container.dataset.embedSrc;
      const chosen       = dataSrc || currentSrc || containerSrc;

      if (liveIframe && currentSrc) {
        // iframe pre-loaded — send play via postMessage (works on iOS in a click handler)
        postPlayCommand(liveIframe);
        overlay.classList.add('is-hidden');
      } else if (liveIframe && chosen) {
        // iframe not yet loaded (e.g. container was off-screen) — fall back to autoplay URL
        const allow = (liveIframe.getAttribute('allow') || '').toLowerCase();
        if (!allow.includes('autoplay')) {
          liveIframe.setAttribute('allow', `${allow ? allow + '; ' : ''}autoplay`);
        }
        liveIframe.setAttribute('src', withAutoplay(chosen));
        overlay.classList.add('is-hidden');
      } else if (!liveIframe && containerSrc) {
        // No iframe in DOM yet but we have a source — create one
        const newIframe = document.createElement('iframe');
        newIframe.setAttribute('src', withAutoplay(containerSrc));
        newIframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        newIframe.setAttribute('allowfullscreen', '');
        newIframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        newIframe.setAttribute('frameborder', '0');
        newIframe.setAttribute('width', '100%');
        newIframe.setAttribute('height', '100%');
        wrapper.insertBefore(newIframe, overlay);
        overlay.classList.add('is-hidden');
      } else {
        console.warn('[embedOverlay] No iframe/source found. Provide data-src on the iframe or data-embed-src on the container.');
      }
    });
  });
}
